import { recallWebSocketService } from './recallWebSocketService';
import { websocketService } from './websocketService';
import { landmineWebSocketService } from './landmineWebSocketService';
import { competitorWebSocketService } from './competitorWebSocketService';
import { calendarWebSocketService } from './calendarWebSocketService';
import { standaloneWatchSocket } from './standaloneWatchSocket';
import { coSellerMicService } from './coSellerMicService';
import { sessionManager } from './sessionManager';

/**
 * Point the coaching sockets at `roomId`: production (objection / FAQ / new
 * inquiry cards) reconnects with the room, and landmine and competitor join it
 * with `join_room`. A bot call and a watched desktop call use the same three;
 * the room is the bot id or the standalone session id.
 */
export const connectAlertSocketsToRoom = async (roomId: string): Promise<void> => {
  sessionManager.setRoomId(roomId);
  await websocketService.reconnectWithNewRoomId();
  landmineWebSocketService.joinRoom(roomId);
  competitorWebSocketService.joinRoom(roomId);
};

/**
 * Close every socket a live call opened: recall, production, landmine,
 * competitor, a watcher's or co-seller's standalone session socket, and a
 * co-seller's own mic (its socket, and the microphone itself). Each
 * `disconnect()` also stops that socket's reconnect loop, so nothing re-joins
 * the ended room.
 * The calendar socket is not touched: the page holds it for its whole life (it
 * is how the next bot is announced).
 */
export const disconnectLiveCallSockets = (): void => {
  recallWebSocketService.disconnect();
  standaloneWatchSocket.disconnect();
  coSellerMicService.stop();
  websocketService.disconnect();
  landmineWebSocketService.disconnect();
  competitorWebSocketService.disconnect();
};

/**
 * The user is being signed out: close every live socket, the calendar one
 * included (it belongs to the signed-in user), so no reconnect loop keeps
 * retrying without a token after the logout. The page reconnects the calendar
 * socket when it mounts for the next sign-in.
 */
export const disconnectAllLiveSockets = (): void => {
  disconnectLiveCallSockets();
  calendarWebSocketService.disconnect();
};
